module.exports = __webpack_public_path__ + "static/Gotham-Light-9249716e1e9daf627a5beec6b4a5adaf.ttf";